export const SPACE_ID = "nj7prbimgo2v";
export const BLOG_URL_ROOT = "blog";
export const BLOG_PAGE_SIZE = 13;
export const TEMPLATE_IDS = {
    LANDING_PAGE: "landingPage",
    CONDITIONS_LANDING_PAGE: "conditionsLandingPages",
    FACTSHEET: "factsheet",
};
export const NON_STATIC_COMPONENT_IDS = {
    WAIT_TIME_CONSULT_BOOK: "Wait Time Consult Book",
};
export const TILE_DISPLAY_VARIANTS = {
    ICON_TILE: "Icon Tile",
    BORDERED_ICON_TILE: "Bordered Icon Tile",
    LIST: "List",
    IMAGE_TILE: "Image Tile",
    NUMBERED_TILES: "Numbered Tiles",
};
export const INFO_CARD_VARIANTS = {
    DEFAULT: "Default",
    CAROUSEL_CARD: "Carousel Card",
    CAROUSEL_CARD_VARIANT: "Carousel Card 2",
    ICON_INFO_CARD: "Icon Info Card",
    BORDERLESS_INFO_CARD: "Borderless Info Card",
    HORIZONTAL_INFO_CARD: "Horizontal Info Card",
    PILL_IMAGE_INFO_CARD: "Pill Image Info Card",
    BANNER_CARD: "Banner Card",
    BANNER_CARD_VARIANT: "Banner Card 2",
    MODAL_INFO_CARD: "Modal Card",
    CONFIGURABLE_CAROUSEL_CARD: "Configurable Carousel Card",
    SELECTABLE_CARD: "Selectable Card",
    LINK_CARD: "Link Card",
    BLOG_CARD: "Blog Card",
};
export const HEADER_IMAGE_VARIANT = {
    SEMI_HEART_MASK: "Semi Heart Mask",
    MOBILE_PARALLAX: "Phone Parallax",
    HOME_PAGE_PARALLAX: "Home Page Parallax",
    DEFAULT: "Default",
    IMAGE_WITH_DESCRIPTION: "Image with description",
};
export const HEADER_TEXT_VARIANT = {
    DEFAULT: "Default",
    HIGHLIGHTED: "Highlighted",
    MEDCERT: "MedCert",
};
export const INFO_CARD_DISPLAY_VARIANTS = {
    CAROUSEL: "Carousel",
    GRID: "Grid",
};
export const BANNER_VARIANTS = {
    DEFAULT: "Default",
    PILL_IMAGE_WITH_TEXT: "Pill Image With Text",
    VIDEO_BANNER: "Video Banner",
    LIST_BANNER: "List Banner",
    BANNER_WITH_HEADER: "Default with header",
};
export const COLOR_KEYS = {
    LIGHT_BLUE: "Light Blue",
    LIGHT_YELLOW: "Light Yellow",
    LIGHT_GREEN: "Light Green",
    PRIMARY_BLUE: "Primary Blue",
    WHITE: "White",
    DARK_BLUE: "Dark Blue",
};
export const NORMALIZED_COLOR_KEYS = {
    LIGHT_BLUE: "lightBlue",
    LIGHT_YELLOW: "lightYellow",
    LIGHT_GREEN: "lightGreen",
    PRIMARY_BLUE: "primaryBlue",
    WHITE: "white",
    DARK_BLUE: "darkBlue",
};
const PRIMARY_VARIANT_STYLES = {
    WRAPPER_COLOR: "bg-is2-blue",
    TEXT_COLOR: "!text-white",
    INVERSE_COLOR: "bg-white",
};
const INFO_VARIANT_STYLES = {
    WRAPPER_COLOR: "bg-is2-blue-50",
    TEXT_COLOR: "!text-is2-gray-500",
    INVERSE_COLOR: "bg-white",
};
const LIGHT_VARIANT_STYLES = {
    WRAPPER_COLOR: "bg-is2-yellow-100",
    TEXT_COLOR: "!text-is2-gray-500",
    TEXT_ACCENT_COLOR: "!text-is2-yellow-900",
    INVERSE_COLOR: "bg-white",
};
const DARK_VARIANT_STYLES = {
    WRAPPER_COLOR: "bg-is2-green-50",
    TEXT_COLOR: "!text-is2-gray-500",
    INVERSE_COLOR: "bg-white",
};
export const NORMAL_VARIANT_STYLES = {
    WRAPPER_COLOR: "bg-white",
    TEXT_COLOR: "!text-is2-gray-500",
    INVERSE_COLOR: "bg-is2-yellow-100",
};
export const VARIANT_STYLE_MAPPING = {
    primary: PRIMARY_VARIANT_STYLES,
    info: INFO_VARIANT_STYLES,
    light: LIGHT_VARIANT_STYLES,
    [COLOR_KEYS.LIGHT_BLUE]: INFO_VARIANT_STYLES,
    [COLOR_KEYS.LIGHT_YELLOW]: LIGHT_VARIANT_STYLES,
    [COLOR_KEYS.LIGHT_GREEN]: DARK_VARIANT_STYLES,
    dark: DARK_VARIANT_STYLES,
    normal: NORMAL_VARIANT_STYLES,
    [COLOR_KEYS.WHITE]: NORMAL_VARIANT_STYLES,
    [COLOR_KEYS.PRIMARY_BLUE]: PRIMARY_VARIANT_STYLES,
};
export const CONTENT_TYPE_IDS = {
    PARAGRAPH: "paragraph",
};
export const CONFIGURATION_TYPE_IDS = {
    CAROUSEL: "Carousel",
    INFO_CARD: "Info Card",
    RICH_TEXT: "Rich Text Styling",
    TILE_LIST: "Tile List",
    BANNER_MEDIA: "Banner Media",
};
export const PAGE_SECTION_IDS = {
    PAGE_HEADER: "pageHeaderSection",
    DOCTOR_CONTENT: "conditionsLandingPageAdaptiveContent",
    TAB_PIVOT: "tabPivotPageSection",
    TILE_LIST: "tileListPageSection",
    INFO_CARD: "infoCardPageSection",
    JOIN_US: "joinUsPageSection",
    BANNER: "landingPageBanner",
    ACCORDION_SECTION: "conditionInformationSection",
    CUSTOM_CONTENT_SECTION: "customContentSection",
};
export const PAGE_IDS = {
    /*
    This is actually a tag
    Treatment pages are dealing with two different content types
    Until they all get migrated to one content type, we will keep this as a tag
    */
    // Revert to the content type ID
    TREATMENT: "conditionsLandingPages",
    LANDING_PAGE: "landingPage",
    BLOG_POST: "blogPost",
    HOMEPAGE: "homepage",
};
